import { render, staticRenderFns } from "./ChipsToggleFilter.vue?vue&type=template&id=3ff5195b"
import script from "./ChipsToggleFilter.vue?vue&type=script&lang=js"
export * from "./ChipsToggleFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports